import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// Create axios instance with auth header
const apiClient = axios.create({
  baseURL: `${API_URL}/cdn`,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add auth token to requests
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('streamToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

class CDNService {
  // Get all CDN configs
  async getConfigs() {
    try {
      const response = await apiClient.get('/configs');
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  // Get single CDN config
  async getConfig(id) {
    try {
      const response = await apiClient.get(`/configs/${id}`);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  // Create new CDN config
  async createConfig(configData) {
    try {
      const response = await apiClient.post('/configs', configData);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  // Update CDN config
  async updateConfig(id, configData) {
    try {
      const response = await apiClient.put(`/configs/${id}`, configData);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  // Delete CDN config
  async deleteConfig(id) {
    try {
      const response = await apiClient.delete(`/configs/${id}`);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  // Test CDN connection
  async testConnection(id) {
    try {
      const response = await apiClient.post(`/configs/${id}/test`);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  // Get supported providers
  async getProviders() {
    try {
      const response = await apiClient.get('/providers');
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  // Get default CDN config
  async getDefaultConfig() {
    try {
      const response = await apiClient.get('/default');
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  // Set default CDN config
  async setDefaultConfig(id) {
    try {
      const response = await apiClient.post(`/configs/${id}/set-default`);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  // Get CDN status
  async getStatus() {
    try {
      const response = await apiClient.get('/status');
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  // Handle errors
  handleError(error) {
    if (error.response) {
      const message = error.response.data?.error || error.response.data?.message || 'An error occurred';
      const code = error.response.data?.code || 'UNKNOWN_ERROR';
      
      const customError = new Error(message);
      customError.code = code;
      customError.status = error.response.status;
      customError.data = error.response.data;
      
      return customError;
    } else if (error.request) {
      const customError = new Error('No response from server');
      customError.code = 'NO_RESPONSE';
      return customError;
    } else {
      return error;
    }
  }
}

export default new CDNService();
